/* global wpApiSettings */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { wpBase } from "../api/base";
import axios from "axios";

// CHECK IF FAVORITED
const checkIfFavorited = createAsyncThunk(
  "favorite/checkIfFavorited",
  async ({ author, userId }, { rejectWithValue }) => {
    try {
      const response = await wpBase.post(
        `/wp-json/fz-details/v1/check-favorite/`,
        {
          author: author,
          userId: userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": wpApiSettings.nonce,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return rejectWithValue(error.message);
    }
  }
);

// ADD FAVORITES
const addFavorite = createAsyncThunk(
  "favorite/addFavorite",
  async ({ id, userId, currentDate, type }, { rejectWithValue }) => {
    try {
      const response = await wpBase.post(
        `/wp-json/fz-details/v2/add-favorites`,
        {
          comment_author: id,
          comment_date: currentDate,
          comment_date_gmt: currentDate,
          comment_type: "intero_favorite",
          comment_content: type,
          user_id: userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": wpApiSettings.nonce,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Error adding favorite:", error);
      return rejectWithValue(error.message);
    }
  }
);

// REMOVE FAVORITES
const removeFavorite = createAsyncThunk(
  "favorite/removeFavorite",
  async ({ author, userId }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `/wp-json/fz-details/v2/favorite/remove`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": wpApiSettings.nonce,
          },
          data: {
            author: author,
            user_id: userId,
          },
        }
      );
      console.log(response.data);
      if (response.status === 200) {
        return {
          author,
          status: response.data.status,
          deleted_rows: response.data.deleted_rows,
        };
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Error removing favorite:", error);
      return rejectWithValue(error.message);
    }
  }
);

export { checkIfFavorited, addFavorite, removeFavorite };
